import { render, staticRenderFns } from "./ExpandableMenu.vue?vue&type=template&id=daff721c"
import script from "./ExpandableMenu.vue?vue&type=script&lang=js"
export * from "./ExpandableMenu.vue?vue&type=script&lang=js"
import style0 from "./ExpandableMenu.vue?vue&type=style&index=0&id=daff721c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports